import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/layouts/default.vue").then(m => m.default || m))
}